export default __webpack_public_path__ + "static/media/Logo symbol.27be01dd.png";